<template>
    <div class="col-xl-12 col-lg-12 col-md-12">
        <div class="form-table form-table--services">
            <div class="form-table__header j-c--s-b">
                Services <span @click="redirect_to_deal">Add new SOW</span>
            </div>
            <div class="table-wrap">
                <table class="table">
                    <thead>
                        <th>Service</th>
                        <th>Type</th>
                        <th>Deal Amount</th>
                        <th>Debt</th>
                        <th>Kick-off date</th>
                        <th>Amount</th>
                        <th>Hard cost</th>
                        <th>Collected</th>
                        <th># of payment</th>
                        <th>Commission</th>
                        <th>Action</th>
                    </thead>
                    <tbody>
                        <tr v-for="__item in sale_items">
                            <td>
                                <span class="link" @click="onEdit(__item)">{{
                                    __item.deal_line_item.services.length
                                        ? __item.deal_line_item.services[0]
                                              .name ||
                                          __item.deal_line_item.custom_service
                                        : __item.deal_line_item
                                              .custom_service ?? "-"
                                }}</span>
                            </td>
                            <td>{{ __item.deal_line_item.type.name }}</td>
                            <td>${{ __item.deal_line_item.amount }}</td>
                            <td class="checkbox">
                                <div class="form-field checkbox-wrap">
                                    <input
                                        disabled
                                        :checked="Boolean(__item.is_overdue)"
                                        type="checkbox"
                                        value=""
                                    />
                                    <label>
                                        <i class="icon icon-checkmark"></i>
                                    </label>
                                </div>
                            </td>
                            <td>{{ __item.kickoff_date }}</td>
                            <td>${{ __item.amount ?? "0.00" }}</td>
                            <td>{{ __item.hard_cost ?? "0.00" }}</td>
                            <td>${{ __item.collected ?? "0.00" }}</td>
                            <td>{{ __item.deal_line_item.num_of_payments }}</td>
                            <td>${{ __item.commission ?? "0.00" }}</td>
                            <td>
                                <a
                                    :href="
                                        __item.deal_line_item.sow.file
                                            ? '/storage/sow/' +
                                              __item.deal_line_item.deal_id +
                                              '/' +
                                              __item.deal_line_item.sow.file
                                            : __item.deal_line_item.sow.url
                                    "
                                    type="button"
                                    style="display: block; margin-bottom: 2px"
                                    v-if="__item.deal_line_item.sow"
                                >
                                    View SOW
                                </a>
                                <a
                                    href="#"
                                    type="button"
                                    style="display: block; margin-bottom: 2px"
                                >
                                    Cancel
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <service-modal
                v-if="item"
                :service="item.deal_line_item"
                :deal_commission_type_id="deal_commission_type_id"
                :max_hard_cost="max_hard_cost"
                :types="types"
                :item="item"
                :onClose="onCloseModal"
                :onUpdateList="onUpdateList"
                :deal_id="deal_id"
                :brand_name="brand"
                :cancel_reasons="cancel_reasons"
                :sale_period="sale_period"
            ></service-modal>
        </div>
    </div>
</template>

<script>
import ServiceModal from "./addService.vue";

export default {
    name: "Sale_Service_Table",
    props: {
        service: Object,
        types: Array,
        sale_items: Array,
        deal_id: Number,
        deal_commission_type_id: Number,
        brand_name: String,
        max_hard_cost: {
            type: Number,
            default: 0,
        },
        cancel_reasons: Array,
        sale_period: String,
    },
    data() {
        return {
            item: null,
            brand: this.brand_name,
        };
    },
    components: {
        "service-modal": ServiceModal,
    },
    methods: {
        onEdit(item) {
            this.item = item;
        },
        onCloseModal() {
            this.item = null;
        },
        onUpdateList(id, item, total_data = {}) {
            try {
                const index = this.sale_items.findIndex((i) => i.id === id);

                this.sale_items[index] = { ...this.sale_items[index], ...item };
                this.afterUpdateItem(total_data);
            } catch (err) {
                console.log("onUpdateList error", err);
            }
        },
        redirect_to_deal() {
            const deal_id = this.deal_id;

            if (deal_id) {
                window.location.href = `/deals/${deal_id}/edit?action=add_new_sow`;
            }
        },

        afterUpdateItem({
            total_amount = 0,
            total_collected = 0,
            total_hard_cost = 0,
            total_commission = 0,
        }) {
            const amountField = document.getElementById("agency_amount"),
                collectedField = document.getElementById("agency_collected"),
                hardCostField = document.getElementById("hard-cost"),
                commissionField = document.getElementById("commision-owed-2");

            if (amountField) {
                amountField.value = total_amount;
            }
            if (collectedField) {
                collectedField.value = total_collected;
            }
            if (hardCostField) {
                hardCostField.value = total_hard_cost;
            }
            if (total_commission) {
                commissionField.value = total_commission;
            }
        },
    },
};
</script>
